import { DonationRecurringType } from "~frontend/__generated__/graphql";

export const DONATION_RECURRING_TYPES_LABELS: {
  [key in DonationRecurringType]: string | null;
} = {
  [DonationRecurringType.OneTime]: null,
  [DonationRecurringType.Weekly]: "Recurring: weekly",
  [DonationRecurringType.Monthly]: "Recurring: monthly",
  [DonationRecurringType.Other]: "Recurring: other",
};
